import { useContext } from 'react';
import { PlannerDataContext, PlannerData } from './PlannerDataContext';

export const usePlannerData = (): PlannerData => {
  const context = useContext(PlannerDataContext);

  if (!context) {
    throw new Error('usePlannerData must be used within PlannerDataProvider');
  }

  return context;
};
